import { render } from "./AcademicYearBreakdownChart.vue?vue&type=template&id=a0fbade8"
import script from "./AcademicYearBreakdownChart.vue?vue&type=script&lang=js"
export * from "./AcademicYearBreakdownChart.vue?vue&type=script&lang=js"
script.render = render

export default script